
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Patient } from "../../../../../domain/patient";
import { ModelEditableMixin } from "../../../../system/mixins";
import { EditingDocument } from "../../EditingDocument";

@Component
export default class PaneMixin extends Mixins(ModelEditableMixin) {
  editingSource: EditingDocument;
  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  @Prop({ default: false })
  isEmbedded: boolean;

  get patient(): Patient {
    return this.readPropertyOrDefault(s => s.attributes.patient, null);
  }
}
